<template>
	<div style="position: relative;">
		<img style="width: 100%; height: 100%;" src="https://sz.daolongsz.com/static/shop.png"/>  
		
		<img style="width: 100px; height: 100px;position: absolute;top: 300px;right: 20px;" src="https://sz.daolongsz.com/static/hand.gif"/>  
		
		<div style="height: 1.2rem;">
			  
		</div>
	</div>
	
</template>

<script>

export default {
    data: function () {
    return {

    };
  },
  created() {
	this.$router.push('/');
  },
  mounted: function () {},
  methods: {
    
  },
};
</script>

<style scoped>


</style>